import { FC, useMemo } from "react";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import TableLinkButtonComponent from "../../../../../../../../common/components/table/button/link/table-link-button.component";
import TableComponent, {
  TableProps,
} from "../../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../../context/app.context";
import orderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper from "./order-optimizer-cargo-details-hidden-details-center-tables-orders-order-table.helper";
import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableRow from "../../types/order-optimizer-cargo-details-hidden-details-center-tables-orders-order-table-row";
import OrderOptimizerDetailsTableDotComponent from "../../../../../../common/dot/order-optimizer-details-orders-table-dot.component";
import {
  OrderOptimizerCargoDetailsItemStepsLastPoint,
  OrderOptimizerCargoDetailsItemStepsOrdersPoints,
} from "../../../../common/types/order-optimizer-cargo-details-item";
import orderOptimizerCargoDetailsHelper from "../../../../order-optimizer-cargo-details.helper";

type OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrdTableProps =
  Pick<TableProps, "isError" | "isLoading"> & {
    allStepPoints: OrderOptimizerCargoDetailsItemStepsOrdersPoints[];
    stepPoints: OrderOptimizerCargoDetailsItemStepsOrdersPoints[];
    stepOffset: number;
    lastPoint: OrderOptimizerCargoDetailsItemStepsLastPoint | null;
  };

const OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrdTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsOrdersPointsItem: OrderOptimizerCargoDetailsItemStepsOrdersPoints,
    index: number,
    lastPoint: OrderOptimizerCargoDetailsItemStepsLastPoint | null
  ): OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableRow => {
    const timeLabel = orderOptimizerCargoDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.time
    );
    const timeTitle = orderOptimizerCargoDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.time
    );

    const distanceLabel = orderOptimizerCargoDetailsHelper.getDistanceLabel(
      detailsStepsOrdersPointsItem.distance
    );
    const distanceTitle = orderOptimizerCargoDetailsHelper.getDistanceLabel(
      detailsStepsOrdersPointsItem.distance
    );

    const haltingTimeLabel = orderOptimizerCargoDetailsHelper.getTimeDeltaLabel(
      detailsStepsOrdersPointsItem.haltingTime
    );
    const haltingTimeTitle = orderOptimizerCargoDetailsHelper.getTimeDeltaLabel(
      detailsStepsOrdersPointsItem.haltingTime
    );

    const dotColor = "#d9d9d9";
    const stepPointIndex = props.stepOffset + index;

    const isFirstPoint = stepPointIndex === 0;
    const isLastStepPoint = index === props.stepPoints.length - 1;

    const googleMapsPoints: OrderOptimizerCargoDetailsItemStepsOrdersPoints[] =
      [];

    if (!isFirstPoint) {
      googleMapsPoints.push(props.allStepPoints[stepPointIndex - 1]);
    }
    googleMapsPoints.push(props.allStepPoints[stepPointIndex]);

    return {
      id: uuidService.generate(),
      value: {
        humanId: (
          <div className="order_optimizer_cargo_details_hidden_details_center_tables_order__humanId">
            <span style={{ width: "8px" }} title={String(stepPointIndex + 1)}>
              {stepPointIndex + 1}
            </span>
            <OrderOptimizerDetailsTableDotComponent color={dotColor} />
          </div>
        ),
        address: (
          <div title={detailsStepsOrdersPointsItem.displayName}>
            {detailsStepsOrdersPointsItem.displayName}
          </div>
        ),
        time: (
          <div
            className={isLastStepPoint ? "last_driver_time" : ""}
            title={timeTitle}
          >
            {timeLabel}
          </div>
        ),
        haltingTime: <div title={haltingTimeTitle!}>{haltingTimeLabel}</div>,
        distance: <div title={distanceTitle}>{distanceLabel}</div>,
        actions: (
          <TableLinkButtonComponent
            icon={faMap}
            openInNewTab
            to={orderOptimizerCargoDetailsHelper.getGoogleMapsUrl(
              googleMapsPoints,
              lastPoint?.lat,
              lastPoint?.lon,
              false
            )}
            type="primary"
          />
        ),
      },
    };
  };

  const rows: OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableRow[] =
    useMemo(() => {
      return props.stepPoints.map((item, index) =>
        createTableRow(item, index, props.lastPoint)
      );
    }, [props.stepPoints, props.lastPoint, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent;
